import { useFormikContext } from 'formik';
import React from 'react';

import { DaytimeDatesSelector } from './DaytimeDatesSelector';
import { OvernightDatesSelector } from './OvernightDatesSelector';
import { RwbDatesSelector } from './RwbDatesSelector';
import { isOvernightServiceSelected, isRwbServiceSelected } from '../../utils';

import type { DateFormat } from '@madpaws/design-system';
import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

type DateSelectorProps = {
  dateFormat?: DateFormat;
  disabledDates?: string[];
  isCalendarIconHidden?: boolean;
  isCheckboxLegendVisuallyHidden?: boolean;
  isFromExpandedSearchBar?: boolean;
  isLabelVisuallyHidden?: boolean;
  name?: string;
  nameFrom?: string;
  nameTo?: string;
  onDayPickerShow?: () => void;
  placeholder?: string;
  rwbStartingFromPlaceholder?: string;
  weekDaySelectorLabel?: string;
};

export const DateSelector = ({
  disabledDates = [],
  isCalendarIconHidden = true,
  isCheckboxLegendVisuallyHidden,
  isLabelVisuallyHidden,
  name,
  nameFrom,
  nameTo,
  dateFormat = 'short',
  placeholder,
  rwbStartingFromPlaceholder,
  weekDaySelectorLabel,
  onDayPickerShow,
  isFromExpandedSearchBar,
}: DateSelectorProps): ReactElement => {
  const {
    values: { service, bookingType },
  } = useFormikContext<SearchFilters>();

  if (
    isOvernightServiceSelected(service.type) ||
    (isFromExpandedSearchBar && service.type === '')
  ) {
    return (
      <div>
        <OvernightDatesSelector
          dateFormat={dateFormat}
          disabledDates={disabledDates}
          isCalendarIconHidden={isCalendarIconHidden}
          isLabelVisuallyHidden={isLabelVisuallyHidden}
          nameFrom={nameFrom}
          nameTo={nameTo}
          onDayPickerShow={onDayPickerShow}
        />
      </div>
    );
  }

  if (isRwbServiceSelected(service.type, bookingType)) {
    return (
      <div>
        <RwbDatesSelector
          dateFormat={dateFormat === 'fancy' ? 'fancy' : dateFormat}
          disabledDates={disabledDates}
          isCalendarIconHidden={isCalendarIconHidden}
          isCheckboxLegendVisuallyHidden={isCheckboxLegendVisuallyHidden}
          isFromExpandedSearchBar={isFromExpandedSearchBar}
          isLabelVisuallyHidden={isLabelVisuallyHidden}
          name={name}
          onDayPickerShow={onDayPickerShow}
          rwbStartingFromPlaceholder={rwbStartingFromPlaceholder}
          rwbplaceholder={placeholder}
          weekDaySelectorLabel={weekDaySelectorLabel}
        />
      </div>
    );
  }

  return (
    <div>
      <DaytimeDatesSelector
        dateFormat={dateFormat}
        disabledDates={disabledDates}
        isCalendarIconHidden={isCalendarIconHidden}
        isFromExpandedSearchBar={isFromExpandedSearchBar}
        isLabelVisuallyHidden={isLabelVisuallyHidden}
        name={name}
        onDayPickerShow={onDayPickerShow}
        placeholder={placeholder}
      />
    </div>
  );
};
